module.exports = __webpack_public_path__ + "static/media/wordsapp.33ca2369.png";